import { useTheme } from '@mui/material';
import DSGrid from '../../../../design-system/DSGrid';
import { PopulatedKlydo } from '../../../../api/klydo';
import KlydoCard from './KlydoCard';
import useDeviceType from '../../../../hooks/useDeviceType';
import DeleteDialog from '../../../../components/DeleteDialog';
import useDeleteKlydo from '../hooks/useDeleteKlydo';
import { useState } from 'react';
import { DELETE_KLYDO_ALERT } from '../../../../consts/alerts';

export type KlydoGridProps = {
  klydos: PopulatedKlydo[];
};

const KlydoGrid = ({ klydos }: KlydoGridProps) => {
  const { spacing } = useTheme();
  const { isMobile } = useDeviceType();
  const [deletedKlydoId, setDeletedKlydoId] = useState<string>('');

  const { isDeleting, handleDeleteKlydo } = useDeleteKlydo(
    deletedKlydoId,
    () => {
      setDeletedKlydoId('');
    },
  );

  return (
    <>
      <DSGrid
        container
        spacing={spacing(2)}
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xxs: '1fr',
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
            xl: 'repeat(4, 1fr)',
            xxl: 'repeat(5, 1fr)',
          },
        }}
      >
        {klydos.map((klydo) => (
          <DSGrid key={klydo.id}>
            <KlydoCard
              klydo={{ ...klydo }}
              isMenuHidden={isMobile}
              isStatic
              handleDeleteKlydo={() => {
                setDeletedKlydoId(klydo.id);
              }}
            />
          </DSGrid>
        ))}
      </DSGrid>
      <DeleteDialog
        isDeleteDialogOpen={!!deletedKlydoId}
        handleConfirmationClick={handleDeleteKlydo}
        handleClose={() => setDeletedKlydoId('')}
        deleteMessage={DELETE_KLYDO_ALERT}
        isDeleting={isDeleting}
      />
    </>
  );
};

export default KlydoGrid;
